/* eslint-disable no-undef */
class VideoStage {
  constructor() {
    this.$videoComponents = $(
      '.videos-player, .videos-navigation, .videos-prime-list, .videos-content-container, .videos-feature-switch, .videos-rating-player, .videos-assign-content-buttons'
    );
    this.$videoContainer = $('.videos-player');
    this.$testContainer = $('.videos-test, .videos-test-placeholder');
    this.$goToTestButton = $('.js-videos-test-button');
    this.$exerciseConversionTab = $('.js-exercise-conversion-button');
    this.$goToVideoButton = $('.js-videos-back-to-video-button');
    this.$videoConversionTab = $('.js-video-conversion-button');
    this.$videoHintOverlay = $('.js-video-hint-overlay');
    this.$videoHintReplayButton = $('.js-video-hint-replay');
    this.$videoHintTestButton = $('.js-video-hint-go-to-test');
    this.$videoHintCloseButton = $('.js-video-hint-close-button');
    this.$assignmentOverlay = $('.js-video-assignment-overlay');
    this.$assignmentReplayButton = $('.js-video-assignment-replay');
    this.$autocontinueOverlay = $('.js-video-autocontinue-overlay');
    this.$autocontinueButton = $('.js-video-autocontinue-cancel-button');
    this.$videoTestAssignedToLearningGroupsPopup = $(
      '#video-test-assigned-to-learning-groups-popup'
    );

    if (this.$videoTestAssignedToLearningGroupsPopup.length) {
      this.videoTestAssignedToLearningGroupsReveal = new Foundation.Reveal(
        this.$videoTestAssignedToLearningGroupsPopup
      );
    }

    this.$toastComponent = $('.js-toast');
    this.$studySmarterToastComponent = $('.js-study-smarter-box-toast');
    this.$videoDescription = $('.videos-description-accordion')[0];
    this.deviceSize = new Sofatutor.Classes.DeviceSizeHelper();
    this.basicTest = null;

    if (this.$autocontinueOverlay.length) {
      this.autocontinueCountdown = null;
      this.setAutocontinueCountdown();
    }

    this.attachEventListeners();
    this.setStageFromUrlParam();
  }

  attachEventListeners() {
    this.$goToTestButton.on('click', () => this.showTest());
    this.$goToVideoButton.on('click', () => this.returnToVideo());
    if (!Sofatutor.logged_in) {
      this.$videoConversionTab.on('click', () => this.returnToVideo());
      this.$exerciseConversionTab.on('click', () => this.showTest());
    }
    this.$videoHintReplayButton.on('click', () => this.replayVideoHint());
    this.$videoHintTestButton.on('click', () => this.showTestFromVideoHint());
    this.$videoHintCloseButton.on('click', () =>
      this.resumeVideoFromVideoHint()
    );
    this.$assignmentReplayButton.on('click', () => this.replayVideo());
    this.$autocontinueButton.on('click', () => this.cancelCountdown());
    $(document).on('exercises::watchVideoSegment', () => this.returnToVideo());
    $(document).on('segmentEnded', () => this.showVideoHintOverlay());
    if (this.showToastComponent()) {
      $(document).on('scroll', () => this.checkScrollPosition());
    }

    if (this.showStudySmarterToastComponent()) {
      $(document).on('scroll', () => this.checkStudyToastScrollPosition());
    }

    if (Sofatutor.player.videoJsLoaded()) {
      this.player()?.on('play', () =>
        this.player()?.on('ended', () => this.handleVideoEnded())
      );
    } else {
      this.player()?.addEventListener('play', () =>
        this.player()?.addEventListener('ended', () => this.handleVideoEnded())
      );
    }
  }

  handleVideoEnded() {
    if (this.$autocontinueOverlay.length) {
      this.showAutocontinueOverlay();
    }

    if (this.$assignmentOverlay.length) {
      this.showAssignmentOverlay();
    }
  }

  showTest = () => {
    this.player()?.pause();
    if (Sofatutor.logged_in) {
      this.$videoComponents.hide();
    } else {
      this.$videoContainer.hide();
    }
    this.$testContainer.show();
    this.initializeTest();
    if (this.$videoTestAssignedToLearningGroupsPopup.length) {
      this.videoTestAssignedToLearningGroupsReveal.open();
      Sofatutor.tracking.amplitude.track(
        'lgstudents_assigned_content_hint_seen',
        this.$videoTestAssignedToLearningGroupsPopup.data('event-properties')
      );
    }
  };

  returnToVideo = () => {
    this.$testContainer.hide();
    if (Sofatutor.logged_in) {
      this.$videoComponents.show();
      if ($('.videos-prime-list .videos-carousel').length) {
        Sofatutor.features.primeListCarousel.reInit();
      }
      if ($('.videos-bonus-list .videos-carousel').length) {
        Sofatutor.features.bonusListCarousel.reInit();
      }
    } else {
      this.$videoContainer.show();
    }
  };

  showVideoHintOverlay = () => {
    this.$videoHintOverlay.addClass('is-active');
    this.$goToTestButton.hide();
  };

  hideVideoHintOverlay = () => {
    this.$videoHintOverlay.removeClass('is-active');
  };

  showAssignmentOverlay = () => {
    if (Sofatutor.player.isNative && this.player()?.webkitExitFullscreen) {
      this.player()?.webkitExitFullscreen();
    }

    this.$assignmentOverlay.addClass('is-active');
  };

  hideAssignmentOverlay = () => {
    this.$assignmentOverlay.removeClass('is-active');
  };

  setAutocontinueCountdown = () => {
    if (this.deviceSize.isPhone()) {
      this.autocontinueCountdown = new Sofatutor.Classes.Countdown(
        '.videos-player-autocontinue-overlay__countdown-small'
      );
    } else {
      this.autocontinueCountdown = new Sofatutor.Classes.Countdown(
        '.videos-player-autocontinue-overlay__countdown'
      );
    }

    this.autocontinueCountdown.addEventListener(
      'countdownEnded',
      this.hideAutocontinueOverlay
    );
  };

  showAutocontinueOverlay = () => {
    if (Sofatutor.player.isNative && this.player()?.webkitExitFullscreen) {
      this.player()?.webkitExitFullscreen();
    }

    this.$autocontinueOverlay.addClass('is-active');
    this.autocontinueCountdown.start();
  };

  hideAutocontinueOverlay = () => {
    this.$autocontinueOverlay.removeClass('is-active');
    this.showTest();
  };

  cancelCountdown = () => {
    this.autocontinueCountdown.stop();
    this.$autocontinueOverlay.removeClass('is-active');
  };

  resetVideoHint = () => {
    this.$goToTestButton.show();
    this.hideVideoHintOverlay();
    if (this.player()?.stopSegment) {
      this.player()?.stopSegment();
    }
  };

  replayVideoHint = () => {
    this.$goToTestButton.show();
    this.hideVideoHintOverlay();
    if (this.player()?.replaySegment) {
      this.player()?.replaySegment();
    }
  };

  replayVideo = () => {
    this.$goToTestButton.show();
    this.hideAssignmentOverlay();

    if (Sofatutor.player.videoJsLoaded()) {
      this.player()?.currentTime(0);
    } else {
      this.player().currentTime = 0;
    }

    this.player()?.play();
  };

  resumeVideoFromVideoHint = () => {
    this.resetVideoHint();
    this.player()?.play();
  };

  showTestFromVideoHint = () => {
    this.resetVideoHint();
    this.showTest();
  };

  setStageFromUrlParam = () => {
    const launchpadUrlParam = new RegExp('[?&_]' + 'launchpad=test').exec(
      window.location.href
    );

    if (launchpadUrlParam) {
      this.showTest();
    }
  };

  player = () => {
    if (Sofatutor.player.videoJsLoaded()) {
      if (Sofatutor.player.isVideoJs5()) {
        return videojs.getPlayers()['player-0'];
      } else {
        return videojs.players['player-0'];
      }
    } else {
      return $('#player-0').get(0);
    }
  };

  initializeTest = () => {
    if ($('#exercises-app').length) {
      this.initializeResponsiveExercises();
    } else {
      this.basicTest = this.basicTest || new Sofatutor.Classes.BasicTest();
      if (Sofatutor.logged_in) {
        window.scrollTo(0, 0);
      }
    }
  };

  initializeResponsiveExercises = () => {
    const exercisesApp = document.getElementById('exercises-app');
    const event = new CustomEvent('exercisesinitialize');
    exercisesApp.dispatchEvent(event);
  };

  showToastComponent = () => {
    if (!Sofatutor.logged_in) {
      return true;
    }
  };

  showStudySmarterToastComponent = () => {
    if (!Sofatutor.logged_in) {
      return true;
    }
  };

  checkScrollPosition = () => {
    if (
      this.scrollPositionPassedVideoDescription() &&
      !$.cookie('_sofatutor_toast_component')
    ) {
      this.$toastComponent.removeClass('hide');
      this.$toastComponent.addClass('animate__fadeInUp');
      $.cookie('_sofatutor_toast_component', 'content', { path: '/' });
      $(document).off('scroll', this.checkScrollPosition);
    }
  };

  checkStudyToastScrollPosition = () => {
    if (
      this.scrollPositionFaqHeadline() &&
      !$.cookie('_sofatutor_study_smarter_toast_component')
    ) {
      this.$studySmarterToastComponent.removeClass('hide');
      this.$studySmarterToastComponent.addClass('animate__fadeInUp');
      $.cookie('_sofatutor_study_smarter_toast_component', 'content', {
        path: '/'
      });
      $(document).off('scroll', this.checkStudyToastScrollPosition);
    }
  };

  scrollPositionFaqHeadline = () => {
    const faqHeadline = $(
      '.videos-accordion__content h2:contains("Häufig gestellte Fragen zum Thema")'
    );
    if (faqHeadline.length) {
      const faqHeadlineTop = faqHeadline.offset().top;
      const windowHeight = $(window).height();
      const scrollTop = $(window).scrollTop();

      if (
        faqHeadlineTop >= scrollTop &&
        faqHeadlineTop <= scrollTop + windowHeight
      ) {
        return true;
      }
    }
  };

  scrollPositionPassedVideoDescription = () => {
    const videoDescriptionTab = $('.videos-content-tab__content--description');
    const description = this.$videoDescription || videoDescriptionTab[0];
    if (
      description?.getBoundingClientRect().bottom <=
      (window.innerHeight || document.documentElement.clientHeight)
    ) {
      return true;
    }
  };
}

$(document).on('turbo:load', () => {
  if ($('.videos-stage').length) {
    new VideoStage();
  }
});

$(document).on('turbo:before-render', () => {
  if (Sofatutor.player.videoJsLoaded()) {
    const player =
      videojs.getPlayers()['player-0'] || videojs.players['player-0'];
    player?.off('play');
    player?.off('ended');
    player?.off('pause');
  } else {
    const player = $('#player-0').get(0);
    player?.removeEventListener('play');
    player?.removeEventListener('ended');
    player?.removeEventListener('pause');
  }
});
